import { cn } from "../../lib/utils";
import { BrandLogoIcon } from "./BrandLogoIcon";

type BrandLogoVariant = "hero" | "header";

interface BrandLogoProps {
  variant?: BrandLogoVariant;
  showWordmark?: boolean;
  wordmarkClassName?: string;
  className?: string;
}

const variantStyles: Record<
  BrandLogoVariant,
  { icon: string; wordmark: string; layout: string }
> = {
  hero: {
    layout: "flex flex-col items-center gap-2 sm:gap-3",
    icon: "h-20 w-20 sm:h-24 sm:w-24",
    wordmark: "text-3xl font-bold text-white drop-shadow-lg sm:text-4xl",
  },
  header: {
    layout: "flex items-center justify-center gap-2",
    icon: "h-10 w-10",
    wordmark: "text-title3 font-semibold text-muted-foreground",
  },
};

/** Bite Balance brand logo — transparent background, self-contained SVG icon. */
const BrandLogo = ({
  variant = "header",
  showWordmark = true,
  wordmarkClassName,
  className,
}: BrandLogoProps) => {
  const styles = variantStyles[variant];

  return (
    <div className={cn(styles.layout, className)}>
      <BrandLogoIcon className={styles.icon} />
      {showWordmark && (
        <span className={cn(styles.wordmark, wordmarkClassName)}>
          Bite Balance
        </span>
      )}
    </div>
  );
};

export default BrandLogo;
export { BrandLogoIcon };
